import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { slice, isEmpty } from 'ramda';

import {
  MAX_DISPLAYED_THUMBNAILS_NUMBER,
  INITIAL_INDEX,
} from '../../pages/constants';
import Column from '../../components/Column';
import Row from '../../components/Row';
import Label from '../../components/Label';
import leftArrow from '../../assets/arrow-left-circle-line.svg';
import rightArrow from '../../assets/arrow-right-circle-line.svg';

import Thumbnail from './components/Thumbnail';
import ImageModal from './components/ImageModal';

const Gallery = (props) => {
  const { images, title } = props;
  const [showFullImage, setShowFullImage] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(INITIAL_INDEX);
  const image = images[selectedImageIndex];
  const imagesSize = images.length;
  const isImagesNumberExceedsMax = imagesSize > MAX_DISPLAYED_THUMBNAILS_NUMBER;
  const [displayedThumbnailsStartIndex, setDisplayedThumbnailsStartIndex] =
    useState(INITIAL_INDEX);
  const [displayedThumbnailsEndIndex, setDisplayedThumbnailsEndIndex] =
    useState(displayedThumbnailsStartIndex + MAX_DISPLAYED_THUMBNAILS_NUMBER);
  const isStartIndexMin = () => {
    return displayedThumbnailsStartIndex === INITIAL_INDEX;
  };
  const isEndIndexMax = () => {
    return displayedThumbnailsEndIndex === imagesSize;
  };
  const dispayedThumbnails = slice(
    displayedThumbnailsStartIndex,
    displayedThumbnailsEndIndex,
    images
  );
  const handleShowNextThumbnails = () => {
    setDisplayedThumbnailsStartIndex(displayedThumbnailsStartIndex + 1);
    setDisplayedThumbnailsEndIndex(displayedThumbnailsEndIndex + 1);
  };
  const handleShowPreviousThumbnails = () => {
    setDisplayedThumbnailsStartIndex(displayedThumbnailsStartIndex - 1);
    setDisplayedThumbnailsEndIndex(displayedThumbnailsEndIndex - 1);
  };
  const handleClick = (index) => {
    setSelectedImageIndex(index);
    setShowFullImage(!showFullImage);
  };
  const handleCloseImageModal = () => {
    setShowFullImage(false);
  };
  const handleNextImageClick = () => {
    selectedImageIndex === imagesSize - 1
      ? setSelectedImageIndex(INITIAL_INDEX)
      : setSelectedImageIndex(selectedImageIndex + 1);
  };
  const handlePreviousImageClick = () => {
    selectedImageIndex === INITIAL_INDEX
      ? setSelectedImageIndex(imagesSize - 1)
      : setSelectedImageIndex(selectedImageIndex - 1);
  };

  return (
    <Column>
      {!isEmpty(title) && <Label name="gallery-label" title={title} />}
      <Row className="-centred-content">
        <ImageModal
          isModalOpen={showFullImage}
          onClose={handleCloseImageModal}
          image={image}
          onNextImageClick={handleNextImageClick}
          onPreviousImageClick={handlePreviousImageClick}
        />
        {isImagesNumberExceedsMax && (
          <button
            className="action-button"
            onClick={handleShowPreviousThumbnails}
            disabled={isStartIndexMin()}
          >
            <img
              className="left-arrow-icon"
              alt="left-arrow-button"
              src={leftArrow}
            />
          </button>
        )}
        {dispayedThumbnails.map((image, index) => (
          <Thumbnail
            key={image.id}
            image={image}
            onClick={(index) => handleClick(index)}
            index={index}
          />
        ))}
        {isImagesNumberExceedsMax && (
          <button
            className="action-button"
            onClick={handleShowNextThumbnails}
            disabled={isEndIndexMax()}
          >
            <img
              className="right-arrow-icon"
              alt="right-arrow-button"
              src={rightArrow}
            />
          </button>
        )}
      </Row>
    </Column>
  );
};

export default Gallery;

Gallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  title: PropTypes.string,
};

Gallery.defaultProps = {
  title: '',
};
